import { Col, Row, Space, Table } from "antd";
import Header from "./header";
import { DashboardSummaryListInterface } from "../Interfaces/DashboardSummaryListInterface";
import { SearchType } from "../Interfaces/SearchInterfaces";
import type { ColumnsType } from "antd/es/table";
// import { Search } from "../../Filter/Search";
import { useTranslation } from "react-i18next";
import ViewButton from "../UI/ViewButton/viewbutton";

type PropsType = {
  picker: string;
  tableKey: number;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
};

const DashboardSummaryList = ({
  picker,
  tableKey,
  searchText,
  setSearchText,
}: PropsType) => {
  const { t } = useTranslation("common");
  const columns: {}[] = [
    {
      title: `${t("items")}`,
      dataIndex: "items",
      key: "items",
    },
    {
      title: `${t("quantity")}`,
      dataIndex: "quantity",
      key: "quantity",
      align: "center" as "center",
    },
    {
      title: `${t("cost")}`,
      dataIndex: "cost",
      key: "cost",
      align: "center" as "center",
    },
    {
      title: `${t("totalt-purchase")}`,
      dataIndex: "purchase",
      key: "purchase",
      align: "center" as "center",
    },
    {
      title: `${t("total-sales")}`,
      dataIndex: "sales",
      key: "sales",
      align: "center" as "center",
    },
    {
      title: `${t("cOGS")}`,
      dataIndex: "cgos",
      key: "cgos",
      align: "center" as "center",
    },
    {
      title: `${t("total-Profit")}`,
      dataIndex: "profit",
      key: "profit",
      align: "center" as "center",
    },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center" as "center",
      render: (record: any) => (
        <Space size="middle">
          <ViewButton onClick={() => console.log("hh")} />
        </Space>
      ),
    },
  ];

  const dataSource: DashboardSummaryListInterface[] = [
    {
      key: "1",
      items: "item1",
      quantity: 32,
      cost: 0,
      purchase: 23,
      sales: 5,
      cgos: 99,
      profit: 111,
    },
    {
      key: "2",
      items: "item1",
      quantity: 32,
      cost: 0,
      purchase: 23,
      sales: 5,
      cgos: 99,
      profit: 111,
    },
    {
      key: "3",
      items: "item3",
      quantity: 32,
      cost: 0,
      purchase: 23,
      sales: 5,
      cgos: 99,
      profit: 111,
    },
    {
      key: "4",
      items: "item4",
      quantity: 32,
      cost: 0,
      purchase: 23,
      sales: 5,
      cgos: 99,
      profit: 111,
    },
  ];
  const searchKeys = ["items"];

  // var searchColumns: ColumnsType<SearchType> = Search(
  //   columns,
  //   searchKeys,
  //   searchText,
  //   setSearchText
  // );

  // searchColumns = searchColumns;

  return (
    <Row>
      <Col offset={1} span={22}>
        <Header picker={picker} hasItems={false} placeholder="Wearhouse" />
        <Table
          scroll={{ x: 1000 }}
          key={tableKey}
          dataSource={dataSource}
          className="dashboard-list"
          columns={columns}
          style={{ marginTop: "15px" }}
          rowClassName={(record, index) =>
            index % 2 === 0
              ? "table-row-light table-row"
              : "table-row-dark table-row"
          }
        />
      </Col>
    </Row>
  );
};

export default DashboardSummaryList;
